import { type ReactElement, type ReactNode } from 'react';

/**
 * Einheitliches Layout fuer einfache Marketing-/Info-Seiten (Ueber uns,
 * Kontakt, Karriere, Blog, API, Status, Doku usw.). Header/Footer kommen
 * vom umgebenden Marketing-Layout (siehe App.tsx).
 */
export default function PageShell({
  title,
  intro,
  children,
}: {
  title: string;
  intro?: string;
  children: ReactNode;
}): ReactElement {
  return (
    <div className="pt-24 pb-16 lg:pt-32 lg:pb-24">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="text-3xl font-bold text-secondary-900 mb-4">{title}</h1>
        {intro && <p className="text-lg text-secondary-600 mb-10">{intro}</p>}
        <div className="space-y-8 text-secondary-700 leading-relaxed">{children}</div>
      </div>
    </div>
  );
}

/** Abschnitt mit Ueberschrift fuer PageShell-Inhalte. */
export function PageSection({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}): ReactElement {
  return (
    <section>
      {title && (
        <h2 className="text-xl font-semibold text-secondary-900 mb-3">{title}</h2>
      )}
      {children}
    </section>
  );
}
